export const getText = (coupon, date) => {
  return `N* de cupon: ${coupon}.  Fecha: ${date}`;
};
